"use client";

import { Suspense } from "react";
import { ConvexClientProvider } from "@/components/providers/ConvexClientProvider";
import { SentryUserSync } from "@/components/providers/SentryUserSync";
import { OnboardingGate } from "@/components/auth/OnboardingGate";
import { WebPresence } from "@/components/presence/WebPresence";
import { CookieConsent } from "@/components/legal/cookie-consent";
import { GlobalParticleBackground } from "@/components/effects/GlobalParticleBackground";
import { Toaster } from "@/components/ui/toast";

export function ClientLayout({ children }: { children: React.ReactNode }) {
  return (
    <ConvexClientProvider>
      <SentryUserSync />
      <div className="relative min-h-screen overflow-hidden bg-background">
        <GlobalParticleBackground />
        <div className="relative z-10">
          <WebPresence />
          <Suspense fallback={null}>
            <OnboardingGate>{children}</OnboardingGate>
          </Suspense>
        </div>
      </div>
      <CookieConsent />
      <Toaster />
    </ConvexClientProvider>
  );
}
